<!-- =========================================================================================
  File Name: DataViewSiblingSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h6>ADD NEW SIBLING FOR :</h6>
        <vs-chip v-if="stuImg" color="primary" class="mr-10">
        <vs-avatar :src="img_cdn+stuImg"/>
        <p v-if="lng=='dogs'"> {{studentFirstName}}</p>
        <p v-else> {{ studentFirstName+' '+studentLastName }}</p>
        </vs-chip>
        <vs-chip v-else color="primary" class="mr-10">
        <vs-avatar/>
        <p v-if="lng=='dogs'"> {{ studentFirstName}}</p>
        <p v-else> {{ studentFirstName+' '+studentLastName }}</p>
        </vs-chip>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <div class="flex">
          <!-- <vs-checkbox v-model="ExBox" @change="excheck(ExBox)">Choose existing Student</vs-checkbox> -->
          <vs-checkbox v-model="NewBox" @change="newcheck(NewBox)">Add New</vs-checkbox>
        </div>
        <span v-if="lng!='dogs'">
        <vs-select  v-if="ExBox" autocomplete v-model="Sibling"  :label="$t('student.add.siblings.select_student')"  class="mt-5 w-full">
          <vs-select-item  :key="item.id" :value="item" :text="item.fname+' '+item.lname" v-for="item in students" />
        </vs-select>
        </span>
         <span v-else>
        <vs-select  v-if="ExBox" autocomplete v-model="Sibling"  :label="$t('student.add.siblings.select_student')"  class="mt-5 w-full">
          <vs-select-item  :key="item.id" :value="item" :text="item.fname" v-for="item in students" />
        </vs-select>
        </span>

      </div>
       <div class="p-6" v-if="NewBox">
            <!-- Product Image -->
        <template >

          <!-- Image Container -->
          <div class="contained-example-container">
            <div id="div-with-loading" class="vs-con-loading__container">
          <!-- Image Container -->

          <div class="img-container w-64 mx-auto flex items-center justify-center vs-con-loading__container" id="div-with-loading">
            <img v-if="dataImg" :src="dataImg" class="responsive">
          </div>
          </div>
            </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">{{this.ImgName == null ? "Upload" : "Update" }} Image</vs-button>
            <vs-button v-if="ImgName!==null" type="flat" color="#999" @click="ImgName = null , dataImg = null">Remove Image</vs-button>
          </div>

        </template>


        <!-- NAME -->
        <vs-input v-if="lng!='dogs'" label="First Name *" v-model="dataFirstName" class="mt-5 w-full" :name="$t('student.add.first_name')" v-validate="'required'" />
        <vs-input v-else :label="$t('student.add.first_name')" v-model="dataFirstName" class="mt-5 w-full" :name="$t('student.add.first_name')" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has($t('student.add.first_name'))">{{ errors.first($t('student.add.first_name')) }}</span>


         <vs-input v-if="lng!='dogs'" :label="$t('student.add.middle_name')"  v-model="dataMiddleName" class="mt-5 w-full" :name="$t('student.add.middle_name')"  />

        <vs-input v-if="lng!='dogs'" :label="$t('student.add.last_name')" v-model="dataLastName" class="mt-5 w-full" :name="$t('student.add.last_name')" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has($t('student.add.last_name'))">{{ errors.first($t('student.add.last_name')) }}</span>
         <!-- NICk Name -->
        <vs-input v-if="lng!='dogs'" :label="$t('student.add.nick_name')"  v-model="dataNick" class="mt-5 w-full" :name="$t('student.add.nick_name')"  /><br>

        <label class="vs-select--label w-full">{{$t('student.add.dob')}}</label>
      <vs-row>
      <vs-col  vs-type="flex" vs-justify="left" vs-align="center" vs-w="12">
    <datepicker class="w-full"  v-model="dataBirthday" format="MM/dd/yyyy"  :minimumView="'day'" :maximumView="'year'" :initialView="'month'"></datepicker><span v-if="dataBirthday" class="mb-8 ml-1"  @click="dataBirthday = null">x</span>

       </vs-col>
  <!-- <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">
   </vs-col> -->
         </vs-row><br>
        <label class="vs-select--label w-full">{{$t('student.add.location')}}</label>
        <ul class="centerx mt-2  flex flex-wrap">
         <li class="ml-1" v-for="location in locations" :key="location.id">
         <vs-radio v-model="dataLocation"  @change="getLocation(location.id,'new')" :vs-value="location">{{location.name}}</vs-radio>
        </li>
        </ul><br>
          <label class="vs-select--label w-full">{{$t('student.add.program')}}</label>
        <v-select  label="name"   :closeOnSelect="true" v-model="dataProgram"  :options="programs"  />
        <span class="text-danger text-sm" v-show="errors.has('item-category')">{{ errors.first('item-category') }}</span><br>
<!--
         <label class="vs-select--label w-full">{{$t('student.add.users')}}</label>
        <v-select  label="name"  multiple :closeOnSelect="true" v-model="dataCamUser"  :options="camusers"  /><br> -->


        <!-- ORDER STATUS -->
<!--        <vs-select v-model="dataRoom" label="Rooms" class="mt-5 w-full">-->
<!--          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in rooms_choices" :multi="true" />-->
<!--        </vs-select>-->
          <label class="vs-select--label w-full">{{$t('student.add.cameras')}}</label>
        <v-select  label="name"  multiple :closeOnSelect="true" v-model="dataCamera" :options="cameras" :dir="$vs.rtl ? 'rtl' : 'ltr'" /><br>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid" >Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import moment from 'moment'
import moduleDataList from '@/store/data-list/moduleDataList.js'
import {ALL_LOCATIONS, CREATE_USER_ACTIVITY, UPDATE_USER_ACTIVITY} from '@/graphql'
import {ALL_CAMERAS} from '@/graphql'
import {ALL_USERS} from '@/graphql'
import {ALL_PROGRAMS_QUERY} from '@/graphql'
import {CREATE_STUDENT,UPDATE_STUDENT,ADD_SIBLING,UPLOAD_IMAGE,GET_STUDENT_BY_LOCATION,GET_CAMERA_BY_LOCATION,GET_PROGRAM_BY_LOCATION} from '@/graphql'
import {ALL_STUDENTS} from '@/graphql'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    Datepicker,
    moment
  },
  data () {
    return {
      students:[],
      locations:[],
      camusers:[],
      cameras:[],
      programs:[],
      dataId: null,
      dataFirstName: '',
      dataMiddleName: '',
      dataLastName: '',
      dataName: '',
      dataProgram: '',
      dataImg: null,
      ImgName:null,
      dataLocation:'',
      dataNick:'',
      dataStatus: false,
      dataBirthday:'',
      dataCamUser:'',
      dataCamera:'',
      dataSibling:'',
      // UpdatedataSibling:[],
      Sibling: null,
      siblingName: '',
      siblingImg: '',
      siblingId: '',
      oldimage:'',
      img_cdn:'',
      lng:'',
      studentFirstName:'',
      studentLastName:'',
      stuImg:'',
      ExBox:true,
      NewBox:false,
      RespID:'',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      const {id,fname,lname,middle_name,nick_name,image,dob,status,location,program,cameras,users,siblings } = JSON.parse(JSON.stringify(this.data))
        this.getStudentBylocation(id)
        this.studentFirstName=fname
        this.studentLastName=lname
        this.stuImg=image
        this.dataId = id
        this.dataSibling = siblings
        this.initValues()
        this.$validator.reset()

      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    // locations() {
    //   return this.$store.state.dataList.locations
    // },

    // camusers() {
    //    var camusers = [];
    //    this.$store.state.dataList.cam_users.length
    //    for (let i = 0; i< this.$store.state.dataList.cam_users.length; i++) {
    //       var fullname = this.$store.state.dataList.cam_users[i].firstname+' '+this.$store.state.dataList.cam_users[i].middlename+' '+this.$store.state.dataList.cam_users[i].lastname
    //       this.$store.state.dataList.cam_users[i].name = fullname;
    //       camusers.push(this.$store.state.dataList.cam_users[i])
    //    }
    //    return camusers
    // },
    // programs () {
    //   return this.$store.state.dataList.programs
    // },
    // cameras () {
    //   return this.$store.state.dataList.cameras
    // },
    isFormValid () {
    if(this.ExBox){
      return !this.errors.any() && this.Sibling
    }
    else{
      if(this.lng=="dogs"){
      this.dataLastName='pet'
      }
      return !this.errors.any() && this.dataProgram !='' && this.dataFirstName && this.dataLastName && this.dataLocation
    }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
        getLocation(location,msg){
        this.$apollo
          .mutate({
           mutation: GET_CAMERA_BY_LOCATION,
           variables: {
           location_id:location
          }
        })
        .then(response => {
          if (response){
          this.cameras=response.data.location_cameras
          if(msg=='new'){
          this.dataCamera=[]
          }
          }
        }) .catch(error => {
          console.log(error)
      });
       this.$apollo
          .mutate({
           mutation: GET_PROGRAM_BY_LOCATION,
           variables: {
           location_id:location
          }
        })
        .then(response => {
          if (response){
          this.programs=response.data.location_programs
          if(msg=='new'){
          this.dataProgram=[]
          }
          }
        }) .catch(error => {
          console.log(error)
      });
    },
    openLoadingInDiv(){
      this.$vs.loading({
        type:'sound',
        container: '#div-with-loading',
        scale: 0.6
      })
    },
    getStudentBylocation(id){
       this.$apollo
        .mutate({
          mutation: GET_STUDENT_BY_LOCATION,
          variables: {
            id:  id
          },
        })
      .then(response => {
        this.students=response.data.getSiblingByLocation.students
      })

    },
     StatusSuccess() {
      this.$emit('getsiblingdata',true)
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text: 'Sibling Added Successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
    SameStudent(){
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text: "Can not add same" +this.$t('student.alert_title')+ " Student to Sibling",
        color: 'danger',
        position: 'top-right'
      })
    },
      StatusFail() {
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text: 'Sibling Failed to add!',
        color: 'danger',
        position: 'top-right'
      })
    },
    initValues () {
      if (this.data.id) return
      this.dataFirstName = ''
      this.dataMiddleName = ''
      this.dataLastName = ''
      this.dataImg = null
      this.ImgName= null
      this.dataNick = ''
      this.dataProgram = ''
      this.dataCamera = []
      this.dataCamUser = []
      this.dataLocation = ''
      this.dataBirthday = ''
      this.dataSibling = []
      this.dataStatus = false
      this.ExBox=true
      this.NewBox=false
    },
    submitData () {
      // var getsiblingsids = [];
      //     for (let j = 0; j< this.dataSibling.length; j++) {
      //     var getid = this.dataSibling[j].id
      //     getsiblingsids.push(getid)
      //   }
      //   this.dataSibling=getsiblingsids
      //   this.UpdatedataSibling=getsiblingsids
      if(this.ExBox){
      this.$validator.validateAll().then(result => {
        if(this.dataId!==this.Sibling.id){
         this.dataSibling=this.Sibling.id
         }
         else{
           this.SameStudent()
           return
         }
        if (result) {
           this.$apollo
          .mutate({
           mutation: ADD_SIBLING,
          variables: {
          student_id:this.dataId,
          sibling_id: this.dataSibling,
          }
        })
        // this.dataSibling=[]
        // this.dataSibling.push(this.dataId)
        //   this.$apollo
        //   .mutate({
        //    mutation: UPDATE_STUDENT,
        //   variables: {
        //   id:this.Sibling.id,
        //   siblings: this.dataSibling,
        //   }
        // })
        .then(response => {
          if (response){
            this.StatusSuccess()
            this.updateUserActivity()
          }
        }).catch(error => {
           this.StatusFail()
          console.log(error)
      });
          this.$emit('closeSidebar')
          this.$emit('getsiblingdata',true)
          this.Sibling = null
          this.initValues()
        }
      })
      }
      if(this.NewBox) {
       var getcamuserids = [];
          for (let j = 0; j< this.dataCamUser.length; j++) {
          var getid = this.dataCamUser[j].id
          getcamuserids.push(getid)
        }
        this.dataCamUser=getcamuserids
         var getcamerasids = [];
          for (let j = 0; j< this.dataCamera.length; j++) {
          var getcameraid = this.dataCamera[j].id
          getcamerasids.push(getcameraid)
        }
        this.dataCamera=getcamerasids
       this.$validator.validateAll().then(result => {
        if (result) {
          console.log(this.dataBirthday)
          if(this.dataBirthday){
            this.dataBirthday=moment(this.dataBirthday).format("YYYY-DD-MM")
          }
          this.$apollo
          .mutate({
           mutation: CREATE_STUDENT,
           variables: {
          fname:this.dataFirstName,
          middle_name:this.dataMiddleName,
          lname: this.dataLastName,
          nick_name: this.dataNick,
          dob:this.dataBirthday,
          image: this.ImgName,
          status: this.dataStatus,
          location_id: this.dataLocation.id,
          program_id: this.dataProgram.id,
          cameras: this.dataCamera,
          users: this.dataCamUser,
          }
        })
        .then(response => {
          if (response){
            this.userActivity(response.data.createStudent.id)
          this.StatusSuccess()
          // this.UpdatedataSibling.push(response.data.createStudent.id)
           this.$apollo
          .mutate({
           mutation: ADD_SIBLING,
          variables: {
          student_id:this.dataId,
          sibling_id:response.data.createStudent.id,
          }
        })
        //   this.$apollo
        //   .mutate({
        //    mutation: UPDATE_STUDENT,
        //   variables: {
        //   id:this.dataId,
        //   siblings: this.UpdatedataSibling,
        //   }
        // })
        //  this.$apollo.mutate({
        //    mutation: UPDATE_STUDENT,
        //   variables: {
        //   id:response.data.createStudent.id,
        //   siblings:this.dataId,
        //   }
        // })
      this.initValues()
      this.$emit('closeSidebar')
      this.$emit('getsiblingdata',true)
      this.dataFirstName = ''
      this.dataMiddleName = ''
      this.dataLastName = ''
      this.dataImg = null
      this.ImgName = null
      this.dataNick = ''
      this.dataProgram = ''
      this.dataLocation = ''
      this.dataBirthday = ''
      this.dataSibling = []
      this.dataStatus = false
        }
        }) .catch(error => {
           this.StatusFail()
          console.log(error)
      });
      this.dataCamera = []
      this.dataCamUser = []
      }
      })
      }
    },
    userActivity ($id) {
      this.$apollo
        .mutate({
          mutation: CREATE_USER_ACTIVITY,
          variables: {
            object_id: $id,
            object_type:"App\\Models\\Student",
            activity:"added"
          }
        }).then(response => {
        if (response){
          this.updateUserActivity()
        }
      })
    },
    updateUserActivity () {

      this.$apollo
        .mutate({
          mutation: UPDATE_USER_ACTIVITY,
          variables: {
            object_id: this.dataId,
            object_type:"App\\Models\\Student",
            activity:"updated"
          }
        })
    },
     updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
           this.openLoadingInDiv();
           this.$apollo
          .mutate({
           mutation: UPLOAD_IMAGE,
           variables: {
           image:this.dataImg,
           oldimage:'',
          }
        })
        .then(response => {
          if (response){
            if(response.data.uploadImage.status=="SUCCESS"){
            this.ImgName = response.data.uploadImage.image_name
            this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            }
            else{
            this.ImgName = response.data.uploadImage.image_name
            this.UploadFail(response.data.uploadImage.error)
            this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            }

          }
        }) .catch(error => {
          console.log(error)
        });
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    excheck(val){
      this.NewBox=!val
    },
    newcheck(val){
       this.ExBox=!val
    },
  },
    created () {
      this.img_cdn=process.env.VUE_APP_IMAGES_CDN_LINK
      this.lng=process.env.VUE_APP_I18N_LOCALE
      this.dataSibling = this.data
      this.$apollo
      .mutate({
        mutation: ALL_LOCATIONS,
      })
      .then(response => {
        this.locations=response.data.locations
      })
       this.$apollo
      .mutate({
        mutation: ALL_USERS,
      })
      .then(response => {
        response.data.role.users.length
         var camusers = [];
       for (let i = 0; i<response.data.role.users.length; i++) {
          var fullname = response.data.role.users[i].fname+' '+response.data.role.users[i].lname
          response.data.role.users[i].name = fullname;
          camusers.push(response.data.role.users[i])
        }
         this.camusers=camusers
      })
  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }

}
</style>
